import { Component, Input } from '@angular/core';

import { BarChartDatePeriod } from '../../../../tms-shared';
import { ChartWeeksSalesInvoiceService } from '../../../services';

@Component({
  selector: 'app-sales-invoice-chart',
  templateUrl: './sales-invoice-chart.component.html',
  styleUrl: './sales-invoice-chart.component.scss',
})
export class SalesInvoiceChartComponent {
  @Input() customerId: string = '';
  @Input() barChartPeriod: BarChartDatePeriod = BarChartDatePeriod.Week;
  @Input() xRotation: number = 0;

  readonly yNameSalesValue = $localize`Sales Value`;

  constructor(public chartWeeksSalesInvoicesService: ChartWeeksSalesInvoiceService) {}
}
